import { useAppStore } from '@/stores/appStore';
import { Loader2, CheckCircle } from 'lucide-react';

export function ScrapeModal() {
  const {
    scrapeModalOpen,
    scrapeProgress,
    scrapeStatus,
    scrapeSource,
    scrapeCompanyName,
  } = useAppStore();

  if (!scrapeModalOpen) return null;

  const sourceLabels: Record<string, string> = {
    linkedin_360: 'LinkedIn 360',
    glassdoor: 'Glassdoor 360',
    consumer_intel: 'Consumer Intel',
    crunchbase: 'Crunchbase',
  };

  const isComplete = scrapeProgress >= 100;

  return (
    <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center">
      <div className="bg-card-dark border border-border-dark rounded-xl max-w-md w-full mx-4 p-6 text-center">
        <div className="mb-4">
          {isComplete ? (
            <CheckCircle className="w-16 h-16 mx-auto text-green-500" />
          ) : (
            <Loader2 className="w-16 h-16 mx-auto text-indigo-500 animate-spin" />
          )}
        </div>

        <h3 className="text-xl font-bold text-white mb-2">
          {isComplete ? 'Scrape Complete!' : `Scraping ${sourceLabels[scrapeSource] || scrapeSource}`}
        </h3>

        <p className="text-gray-400 mb-2">{scrapeCompanyName}</p>

        <p className="text-sm text-gray-500 mb-4">
          {isComplete ? 'Data has been saved.' : 'This may take 30-60 seconds...'}
        </p>

        <div className="w-full bg-gray-700 rounded-full h-2 mb-4">
          <div
            className={`h-2 rounded-full transition-all duration-500 ${
              isComplete ? 'bg-green-500' : 'bg-indigo-500'
            }`}
            style={{ width: `${scrapeProgress}%` }}
          />
        </div>

        <p className="text-sm text-gray-500">{scrapeStatus}</p>
      </div>
    </div>
  );
}
